import React from 'react';

import { ConversationMessageAssistant } from './ConversationMessageAssistant';
import { ConversationMessageUser } from './ConversationMessageUser';
import type { Message } from './types';

interface ConversationMessageProps {
  message: Message;
  className?: string;
}

export const ConversationMessage = ({ message, className }: ConversationMessageProps) => {
  switch (message.role) {
    case 'ai':
      return <ConversationMessageAssistant message={message} className={className} />;
    case 'user':
      return <ConversationMessageUser message={message} className={className} />;
    default:
      return null;
  }
};
